import React from "react";
import { AppSummaryGridContainer } from "../../App";
import TopicSummaryGridContainer from "../../Topic/Components/Common/TopicSummaryGrid/TopicSummaryGridContainer";
import { PageTitleSetter, appPageTitles } from "../../Common";

export default class HomePageContainer extends React.Component {
  render() {
    return (
      <div>
        <PageTitleSetter title={appPageTitles.general} />
        <AppSummaryGridContainer />
        <hr />
        <TopicSummaryGridContainer />
      </div>
    );
  }
}
